import { useEffect, useState } from "react";
import { StyledBarCodeScannerPanel } from "./BarCodeScannerPanel.styles";
import { Container, Row } from "react-grid-system";
import { BarcodeScanner, DetectedBarcode } from "react-barcode-scanner";
import "react-barcode-scanner/polyfill";

interface IBarCodeScannerPanel {
  onValidate?: (failed: boolean, value?: any) => void;
}

export const BarCodeScannerPanel: React.FC<IBarCodeScannerPanel> = ({
  onValidate,
}: IBarCodeScannerPanel) => {
  const [data, setData] = useState<string>();
  const [errors, setErrors] = useState("");
  const [paused, setPaused] = useState(false);
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);

  const handleDevices = (mediaDevices: MediaDeviceInfo[]) => {
    const cameras = mediaDevices.filter(({ kind }) => kind === "videoinput");
    setDevices(cameras);
  };

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(handleDevices);
  }, []);

  return (
    <StyledBarCodeScannerPanel>
      <Container fluid>
        {devices.length > 0 ? (
          <Row align="stretch">
            <BarcodeScanner
              options={{
                delay: 1000,
                formats: [
                  "qr_code",
                  "code_128",
                  "code_39",
                  "codabar",
                  "ean_13",
                  "ean_8",
                ],
              }}
              trackConstraints={
                devices.length > 1
                  ? {
                      facingMode: {
                        exact: "environment",
                      },
                    }
                  : {
                      facingMode: {
                        ideal: "environment",
                      },
                    }
              }
              paused={paused}
              onCapture={(barcodes: DetectedBarcode[]) => {
                if (barcodes?.length > 0) {
                  onValidate?.(false, barcodes[0].rawValue);
                  setData(barcodes[0].rawValue);
                  setPaused(true);
                } else {
                  onValidate?.(false, "");
                  setErrors("Not Found");
                }
              }}
            />
          </Row>
        ) : (
          <></>
        )}
        <Row align="stretch">
          <p>{data}</p>
        </Row>
        <Row align="stretch">
          <h3 style={{ color: "red" }}>{errors}</h3>
        </Row>
      </Container>
    </StyledBarCodeScannerPanel>
  );
};
